import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import CardSlider from './components/CardSlider';
import RespondDrawModal from './components/RespondDrawModal';
import SelectBattleDeckModal from './components/SelectBattleDeckModal';
let sliderState = {
  discussionId: null,
  battle: null,
  deckCards: [],
  playedCardIds: [],
  loaded: false,
  loading: false,
  lastPostCount: 0,
  selectedElementalId: null,
  selectedBonusId: null,
  drawModalShownForBattleId: null,
  deckModalShownForBattleId: null
};
async function refreshSliderState(discussionId) {
  var _actor$attribute, _activeBattles$find;
  const actor = app.session.user;
  if (!actor || sliderState.loading) return;

  // A user can have several concurrent active battles (one per opponent), so
  // this is a list — find the one, if any, that belongs to the discussion
  // currently being viewed rather than assuming there's only one.
  const activeBattles = (_actor$attribute = actor.attribute('arenaActiveBattles')) != null ? _actor$attribute : [];
  const activeBattleInfo = (_activeBattles$find = activeBattles.find(b => b.discussionId === discussionId)) != null ? _activeBattles$find : null;
  if (!activeBattleInfo) {
    sliderState = _objectSpread(_objectSpread({}, sliderState), {}, {
      battle: null,
      loaded: true,
      discussionId
    });
    return;
  }
  sliderState.loading = true;
  try {
    var _battles$find;
    const battles = await app.store.find('arena-battles');
    const battle = (_battles$find = battles.find(b => b.discussionId() === discussionId && b.status() === 'active')) != null ? _battles$find : null;
    let deckCards = [];
    let playedCardIds = [];
    if (battle) {
      var _turnData$challengerP, _turnData$opponentPla;
      const isChallenger = battle.challengerId() === parseInt(actor.id());

      // The deck slot THIS battle was created with (see
      // CreateBattleController) — not the player's currently-selected
      // default deck in the profile editor. They may have switched decks
      // around since; the battle keeps using whatever it started with.
      const deckSlotId = isChallenger ? battle.challengerDeckSlotId() : battle.opponentDeckSlotId();
      let deckCardIds = [];
      if (deckSlotId != null) {
        var _deckResponse$cardIds;
        const deckResponse = await app.request({
          method: 'GET',
          url: "".concat(app.forum.attribute('apiUrl'), "/arena/deck-slots/").concat(deckSlotId, "/cards")
        });
        deckCardIds = (_deckResponse$cardIds = deckResponse.cardIds) != null ? _deckResponse$cardIds : [];
      }

      // CardResource's JSON:API index — replaced the raw GET /arena/cards.
      const pushedCards = await app.store.find('arena-cards', {
        page: {
          limit: 500
        }
      });
      const allCards = Array.isArray(pushedCards) ? pushedCards : pushedCards ? [pushedCards] : [];
      deckCards = allCards.filter(c => deckCardIds.includes(parseInt(c.id())));
      const turnData = await app.request({
        method: 'GET',
        url: "".concat(app.forum.attribute('apiUrl'), "/arena/battles/").concat(battle.id(), "/played-cards")
      });
      playedCardIds = isChallenger ? (_turnData$challengerP = turnData.challengerPlayedCardIds) != null ? _turnData$challengerP : [] : (_turnData$opponentPla = turnData.opponentPlayedCardIds) != null ? _turnData$opponentPla : [];
    }
    sliderState = _objectSpread(_objectSpread({}, sliderState), {}, {
      discussionId,
      battle,
      deckCards,
      playedCardIds,
      loaded: true,
      loading: false,
      selectedElementalId: null,
      selectedBonusId: null,
      // Reset the auto-open flag once the draw proposal is gone, so the modal
      // shows again next time one comes in.
      drawModalShownForBattleId: (battle == null ? void 0 : battle.drawProposedById()) != null ? sliderState.drawModalShownForBattleId : null,
      // Same idea: once this player has played a card (or there's no battle
      // left), the deck can no longer be changed, so the flag resets and the
      // modal is free to show again for whatever battle comes next.
      deckModalShownForBattleId: battle && playedCardIds.length === 0 ? sliderState.deckModalShownForBattleId : null
    });
  } catch (_unused) {
    sliderState = _objectSpread(_objectSpread({}, sliderState), {}, {
      loaded: true,
      loading: false
    });
  }
  m.redraw();
}
function handleSelectElemental(card) {
  const cardId = parseInt(card.id());
  sliderState.selectedElementalId = sliderState.selectedElementalId === cardId ? null : cardId;
  m.redraw();
}
function handleSelectBonus(card) {
  const cardId = parseInt(card.id());
  sliderState.selectedBonusId = sliderState.selectedBonusId === cardId ? null : cardId;
  m.redraw();
}

// Refreshes the post stream of the discussion currently being viewed so the
// new system post (turn/surrender/draw) appears immediately, the same way
// Flarum's own ReplyComposer does it (app.current.get('stream').goToLast()).
// No route change, no full page reload.
//
// stream.update()/count() reads discussion.postIds().length from the local
// store — it never asks the server "are there new posts?". Our card-play
// post is created via a raw app.request() (not store.createRecord().save()),
// so its response never gets pushed into the store and the discussion's
// postIds()/postCount stay stale. The arena system post (created server-side,
// synchronously, in the Posted listener — see ProcessCardPlay::
// handlePostedInternal) is equally invisible to the client until the
// discussion model itself is re-fetched. So: refetch the discussion first
// (which pulls in both new post IDs), THEN let the stream catch up.
//
// goToLast() is used instead of update(): update() only loads the new range
// if stream.viewingEnd() is already true (visibleEnd within 1 of count()),
// so if the user had scrolled up even slightly, the new post would be
// fetched into the store but never rendered or scrolled to — exactly the
// "have to click Показать ещё / scroll down" bug. goToLast() unconditionally
// loads the last page and scrolls to it, which is what core's own
// ReplyComposer does after posting a normal reply.
function refreshPostStream(discussionId) {
  const stream = app.current.get('stream');
  if (discussionId !== null && stream && typeof stream.goToLast === 'function') {
    app.store.find('discussions', String(discussionId)).then(() => stream.goToLast()).then(() => m.redraw()).catch(() => {
      // If the refetch fails, fall back to the old soft re-navigation
      // rather than leaving the stream silently stale.
      const path = m.route.get();
      m.route.set('/');
      setTimeout(() => m.route.set(path), 50);
    });
  } else {
    // No active stream (shouldn't normally happen while a slider is shown):
    // soft re-navigation forces DiscussionPage to remount.
    const path = m.route.get();
    m.route.set('/');
    setTimeout(() => m.route.set(path), 50);
  }
  if (discussionId !== null) {
    refreshSliderState(discussionId);
  }
}
async function submitTurn() {
  const _sliderState = sliderState,
    selectedElementalId = _sliderState.selectedElementalId,
    selectedBonusId = _sliderState.selectedBonusId,
    discussionId = _sliderState.discussionId;
  if (!selectedElementalId || !discussionId) return;
  let content = "[arena-card=".concat(selectedElementalId, "]");
  if (selectedBonusId) content += "\n[arena-card=".concat(selectedBonusId, "]");
  await app.request({
    method: 'POST',
    url: "".concat(app.forum.attribute('apiUrl'), "/posts"),
    body: {
      data: {
        type: 'posts',
        attributes: {
          content
        },
        relationships: {
          discussion: {
            data: {
              type: 'discussions',
              id: String(discussionId)
            }
          }
        }
      }
    }
  });
  hideSlider();
  refreshPostStream(discussionId);
}
function hideSlider() {
  sliderState.battle = null;
  sliderState.loaded = true;
  sliderState.selectedElementalId = null;
  sliderState.selectedBonusId = null;
  m.redraw();
}

// Unlike surrender/draw (which keep the discussion, just lock it with a
// final post), a decline deletes the battle's discussion server-side — so
// there's nothing left to refetch/scroll to. Send the player back to the
// forum index instead of calling refreshPostStream(), which would try to
// re-fetch a discussion that no longer exists.
function handleDeclined() {
  hideSlider();
  sliderState = _objectSpread(_objectSpread({}, sliderState), {}, {
    discussionId: null,
    battle: null,
    loaded: true
  });
  m.route.set(app.route('index'));
}
function buildSlider(battle, wrapClass) {
  const actor = app.session.user;
  const mana = battle.challengerId() === parseInt(actor.id()) ? battle.challengerMana() : battle.opponentMana();
  const available = sliderState.deckCards.filter(c => !sliderState.playedCardIds.includes(parseInt(c.id())));
  const bonusCards = available.filter(c => {
    var _c$isBonus, _c$isBonus2, _c$cardType;
    return (_c$isBonus = (_c$isBonus2 = c.isBonus) == null ? void 0 : _c$isBonus2.call(c)) != null ? _c$isBonus : ((_c$cardType = c.cardType) == null ? void 0 : _c$cardType.call(c)) === 'bonus';
  });
  const canSubmit = sliderState.selectedElementalId !== null && (bonusCards.length === 0 || sliderState.selectedBonusId !== null);
  return m("div", {
    className: wrapClass
  }, m(CardSlider, {
    cards: sliderState.deckCards,
    playedCardIds: sliderState.playedCardIds,
    mana: mana,
    battle: battle,
    selectedElementalId: sliderState.selectedElementalId,
    selectedBonusId: sliderState.selectedBonusId,
    onSelectElemental: handleSelectElemental,
    onSelectBonus: handleSelectBonus,
    onSubmitTurn: submitTurn,
    canSubmit: canSubmit,
    onSurrendered: () => refreshPostStream(sliderState.discussionId),
    onDrawProposed: () => refreshPostStream(sliderState.discussionId),
    onDeclined: handleDeclined
  }));
}

// Status bar shown while a draw proposal is pending: turn timer is paused and
// the normal card slider is hidden. Proposer sees "waiting for response";
// the other player sees "opponent proposed a draw" + a button to reopen the
// response modal.

let _cancelDrawLoading = false;
function cancelDraw(battle) {
  if (_cancelDrawLoading) return;
  _cancelDrawLoading = true;
  app.request({
    method: 'POST',
    url: "".concat(app.forum.attribute('apiUrl'), "/arena/battles/").concat(battle.id(), "/cancel-draw")
  }).then(() => {
    refreshPostStream(sliderState.discussionId);
  }).catch(() => {
    app.alerts.show({
      type: 'error'
    }, app.translator.trans('forumaker-arena.forum.propose_draw.cancel_error'));
  }).finally(() => {
    _cancelDrawLoading = false;
  });
}
function buildDrawPendingBar(battle, wrapClass, isProposer) {
  var _opponentUser$display;
  const opponentId = battle.drawProposedById();
  const opponentUser = app.store.getById('users', String(opponentId));
  const opponentName = (_opponentUser$display = opponentUser == null ? void 0 : opponentUser.displayName()) != null ? _opponentUser$display : app.translator.trans('forumaker-arena.forum.respond_draw.player_fallback', {
    id: opponentId
  });
  return m("div", {
    className: wrapClass
  }, m("div", {
    className: "ArenaCardSlider ArenaCardSlider--drawPending"
  }, m("div", {
    className: "ArenaFinalPost ArenaFinalPost--draw ArenaCardSlider-drawPendingBar"
  }, m("div", {
    className: "ArenaFinalPost-icon"
  }, m("i", {
    className: "fas fa-handshake"
  })), m("div", {
    className: "ArenaFinalPost-body"
  }, m("div", {
    className: "ArenaFinalPost-title"
  }, isProposer ? app.translator.trans('forumaker-arena.forum.propose_draw.waiting_title') : app.translator.trans('forumaker-arena.forum.respond_draw.pending_title')), m("div", {
    className: "ArenaFinalPost-subtitle"
  }, m("i", {
    className: "fas fa-hourglass-half"
  }), isProposer ? app.translator.trans('forumaker-arena.forum.propose_draw.waiting_subtitle') : app.translator.trans('forumaker-arena.forum.respond_draw.pending_subtitle', {
    name: m("strong", null, opponentName)
  }))), !isProposer && m("button", {
    type: "button",
    className: "Button Button--primary ArenaCardSlider-drawPendingBtn",
    onclick: () => openRespondDrawModal(battle, opponentName)
  }, app.translator.trans('forumaker-arena.forum.respond_draw.respond_btn')), isProposer && m("button", {
    type: "button",
    className: "Button ArenaCardSlider-drawPendingBtn ArenaCardSlider-drawCancelBtn",
    onclick: () => cancelDraw(battle)
  }, app.translator.trans('forumaker-arena.forum.propose_draw.cancel_proposal_btn')))));
}
function openRespondDrawModal(battle, proposerName) {
  app.modal.show(RespondDrawModal, {
    battle,
    proposerName,
    onResponded: () => refreshPostStream(sliderState.discussionId)
  });
}

// Shown both by the auto-open trigger below (see the portal's view()) and by
// CardSlider's manual "change deck" button — a plain refresh is enough here,
// no post was created, just a battle row update, so refreshSliderState()
// alone (not refreshPostStream()) is all that's needed to pick up the new
// deck's cards.
function openSelectDeckModal(battle, currentDeckSlotId) {
  app.modal.show(SelectBattleDeckModal, {
    battle,
    currentDeckSlotId,
    onSelected: () => {
      if (sliderState.discussionId !== null) refreshSliderState(sliderState.discussionId);
    }
  });
}

// Portal: the slider is mounted via m.mount() directly into document.body,
// outside any Flarum layout. m.mount() participates in autoredraw and
// doesn't interfere with routing (unlike m.render() inside view()).

let _portalMounted = false;
function ensurePortalMounted() {
  if (_portalMounted) return;
  _portalMounted = true;
  const el = document.createElement('div');
  el.id = 'arena-slider-portal';
  // Outer container is full-width, transparent, no pointer events — same
  // pattern as Flarum's .App-composer (fixed left/right/bottom). All visual
  // styling and height clamping happens on the inner .ArenaCardSlider-portalInner.
  Object.assign(el.style, {
    position: 'fixed',
    left: '0',
    right: '0',
    bottom: '10px',
    zIndex: '1020',
    pointerEvents: 'none',
    display: 'none'
  });
  document.body.appendChild(el);

  // Portal geometry (left/right, see view() below) is only recalculated
  // inside m.mount()'s view(), which Mithril calls on m.redraw() — without an
  // explicit resize listener, dragging the window to a smaller screen left
  // the slider stretched to the old width until some unrelated redraw fired.
  // Triggering redraw on resize ourselves fixes it; rAF coalesces frequent
  // resize events into one redraw per frame.
  let resizeRaf = null;
  window.addEventListener('resize', () => {
    if (resizeRaf !== null) return;
    resizeRaf = requestAnimationFrame(() => {
      resizeRaf = null;
      m.redraw();
    });
  });
  m.mount(el, {
    view: () => {
      var _app$session;
      const actor = (_app$session = app.session) == null ? void 0 : _app$session.user;
      const inBattle = !!actor && sliderState.loaded && !!sliderState.battle;

      // Auto-open the deck-confirmation modal for the side that didn't get
      // to pick their deck explicitly (see SelectBattleDeckModal's class
      // doc) — the opponent's deck slot is auto-locked the moment
      // CreateBattleController creates the battle, well before their first
      // turn might come up, so this fires regardless of whose turn it
      // currently is (unlike the card slider itself, gated by isMyTurn
      // below). Only ever targets the opponent: the challenger already
      // picked explicitly in ChallengeModal.
      if (inBattle) {
        const battle = sliderState.battle;
        const battleId = parseInt(battle.id());
        const isOpponent = battle.opponentId() === parseInt(actor.id());
        const hasPlayed = sliderState.playedCardIds.length > 0;

        // battle.opponentDeckConfirmed() is the persisted signal (see
        // BattleResource/opponent_deck_confirmed_at): without it, a plain
        // page reload reset the purely-client-side deckModalShownForBattleId
        // flag and re-popped this modal on every load until the challenger's
        // first move, and joining an open battle (where the deck was already
        // explicitly picked in JoinBattleModal) would immediately show it
        // again too. deckModalShownForBattleId now only guards against
        // re-opening it twice within the same page view while waiting on
        // that first refetch.
        if (isOpponent && !hasPlayed && !battle.opponentDeckConfirmed() && sliderState.deckModalShownForBattleId !== battleId) {
          sliderState.deckModalShownForBattleId = battleId;
          setTimeout(() => openSelectDeckModal(battle, battle.opponentDeckSlotId()), 0);
        }
      }
      const drawProposedById = inBattle ? sliderState.battle.drawProposedById() : null;
      const pendingDraw = inBattle && drawProposedById !== null;
      const isMyTurn = inBattle && sliderState.battle.nextPlayerId() === parseInt(actor.id());
      const shouldShow = inBattle && (isMyTurn || pendingDraw);

      // Body class hides the default Composer while a battle is active
      document.body.classList.toggle('ArenaInBattle', inBattle);
      if (!shouldShow) {
        el.style.display = 'none';
        return null;
      }
      if (pendingDraw) {
        const isProposer = drawProposedById === parseInt(actor.id());

        // Auto-open the response modal for the other player once per proposal.
        if (!isProposer && sliderState.drawModalShownForBattleId !== parseInt(sliderState.battle.id())) {
          var _opponentUser$display2;
          sliderState.drawModalShownForBattleId = parseInt(sliderState.battle.id());
          const opponentUser = app.store.getById('users', String(drawProposedById));
          const opponentName = (_opponentUser$display2 = opponentUser == null ? void 0 : opponentUser.displayName()) != null ? _opponentUser$display2 : app.translator.trans('forumaker-arena.forum.respond_draw.player_fallback', {
            id: drawProposedById
          });
          setTimeout(() => openRespondDrawModal(sliderState.battle, opponentName), 0);
        }
      }

      // The "draw proposed" bar is a status banner, not a floating composer.
      // It used to render in the same fixed portal as the turn slider and
      // always stuck to the bottom of the screen, detached from the last
      // post. Now the portal is moved right after .PostStream so it lives in
      // normal document flow and scrolls with the page.
      if (pendingDraw) {
        const streamEl = document.querySelector('.DiscussionPage .PostStream');
        if (streamEl != null && streamEl.parentElement && el.previousElementSibling !== streamEl) {
          streamEl.insertAdjacentElement('afterend', el);
        }
        Object.assign(el.style, {
          position: 'static',
          left: '',
          right: '',
          bottom: '',
          zIndex: '5'
        });
        el.style.display = 'block';
        const isProposer = drawProposedById === parseInt(actor.id());
        return buildDrawPendingBar(sliderState.battle, 'ArenaCardSlider-portalInner ArenaCardSlider-portalInner--inline', isProposer);
      }

      // The normal turn slider stays a floating composer at the bottom of the screen.
      if (el.parentElement !== document.body) {
        document.body.appendChild(el);
      }
      Object.assign(el.style, {
        position: 'fixed',
        zIndex: '1020',
        bottom: '10px'
      });

      // Desktop (>=992px, .Page--cols active): align to the content column.
      // Mobile/tablet: full-width, since there's no column and .Page-content fills the screen.
      const contentCol = window.innerWidth >= 992 ? document.querySelector('.DiscussionPage .Page-content') : null;
      if (contentCol) {
        const rect = contentCol.getBoundingClientRect();
        el.style.left = Math.round(rect.left) + 'px';
        el.style.right = Math.round(window.innerWidth - rect.right) + 'px';
      } else {
        el.style.left = '0';
        el.style.right = '0';
      }
      el.style.display = 'block';
      return buildSlider(sliderState.battle, 'ArenaCardSlider-portalInner');
    }
  });
}
export default function addCardSlider() {
  // Reset state on navigating to a different discussion. The first oninit
  // also creates the portal — by this point app.session is already ready.
  extend(DiscussionPage.prototype, 'oninit', function () {
    ensurePortalMounted();
    sliderState = {
      discussionId: null,
      battle: null,
      deckCards: [],
      playedCardIds: [],
      loaded: false,
      loading: false,
      lastPostCount: 0,
      selectedElementalId: null,
      selectedBonusId: null,
      drawModalShownForBattleId: null,
      deckModalShownForBattleId: null
    };

    // The current user's arenaActiveBattles attribute is cached in the SPA
    // session and only refreshed on a full forum load. If a battle/draw
    // proposal/surrender happened after the page loaded and this user hasn't
    // made a request that re-fetches their own user model, the attribute
    // stays stale (missing the new battle) and the whole battle UI fails to
    // render. Forcing a refetch of the own profile on entering any
    // discussion guarantees a freshly created battle or draw proposal is
    // visible immediately.
    const actor = app.session.user;
    if (actor) {
      app.store.find('users', actor.id()).then(() => m.redraw()).catch(() => {});
    }
  });

  // The portal doesn't auto-unmount on leaving the discussion page — it lives
  // in document.body independently of DiscussionPage. Without this reset,
  // sliderState.battle stayed stale and the slider remained visible,
  // stretched full-width, on unrelated forum pages.
  extend(DiscussionPage.prototype, 'onremove', function () {
    sliderState = {
      discussionId: null,
      battle: null,
      deckCards: [],
      playedCardIds: [],
      loaded: false,
      loading: false,
      lastPostCount: 0,
      selectedElementalId: null,
      selectedBonusId: null,
      drawModalShownForBattleId: null,
      deckModalShownForBattleId: null
    };
    m.redraw();
  });

  // DiscussionPage.view only tracks turn changes to refresh data; the portal
  // itself is managed independently via m.mount() above.
  extend(DiscussionPage.prototype, 'view', function () {
    var _actor$attribute2, _activeBattles$find2, _discussion$attribute, _length, _discussion$postIds;
    const actor = app.session.user;
    if (!actor) return;
    const discussion = this.discussion;
    if (!discussion) return;
    const discussionId = parseInt(discussion.id());
    // Same "match against the viewed discussion" logic as refreshSliderState:
    // the user may have another active battle open in a different discussion
    // at the same time, which must not affect this one.
    const activeBattles = (_actor$attribute2 = actor.attribute('arenaActiveBattles')) != null ? _actor$attribute2 : [];
    const activeBattleInfo = (_activeBattles$find2 = activeBattles.find(b => b.discussionId === discussionId)) != null ? _activeBattles$find2 : null;
    if (!activeBattleInfo) return;

    // 'postCount' isn't a real Discussion attribute (Flarum core calls it
    // commentCount) — this comparison was silently always 0 !== 0, so it
    // never once detected a new post, from either our own submitted turn OR
    // a realtime-pushed opponent turn. (Our own turn's slider hide/refresh
    // still worked regardless, since submitTurn() calls hideSlider() +
    // refreshPostStream() directly — this check only ever mattered for
    // catching the *opponent's* move.)
    //
    // Fixed to commentCount, plus postIds().length as a second signal:
    // commentCount is a plain attribute that only changes when the
    // discussion resource itself gets re-serialized by the server: our own
    // refreshPostStream() does that explicitly, but a realtime extension
    // pushing the opponent's turn in over its own channel may only
    // pushPayload() the new post and append its id to the discussion's
    // postIds() relationship (the same thing that makes the post visually
    // appear in the stream without a reload) without also patching
    // commentCount. postIds().length is already in sync the moment the new
    // post is visible, so taking the max of both keeps this working however
    // the realtime extension chooses to push the update.
    const currentPostCount = Math.max((_discussion$attribute = discussion.attribute('commentCount')) != null ? _discussion$attribute : 0, (_length = (_discussion$postIds = discussion.postIds) == null || (_discussion$postIds = _discussion$postIds.call(discussion)) == null ? void 0 : _discussion$postIds.length) != null ? _length : 0);
    if (sliderState.loaded && sliderState.lastPostCount > 0 && currentPostCount !== sliderState.lastPostCount) {
      sliderState.loaded = false;
      sliderState.selectedElementalId = null;
      sliderState.selectedBonusId = null;
    }
    sliderState.lastPostCount = currentPostCount;
    if (!sliderState.loaded && !sliderState.loading) {
      refreshSliderState(discussionId);
    }
  });
}